import {
  ReadEntityNodeData,
  WriteEntityNodeData,
} from "src/constants/NodeDataTypes";
import { SearchableField } from "src/flowGraph/canvasSearch/extractNodeFields";
import { extractWithPrefix } from "src/flowGraph/canvasSearch/nodesExtractors/utils";

export const extractReadEntityNodeFields = (
  data: ReadEntityNodeData,
): SearchableField[] => [
  data.entity_ids_expression,
  extractWithPrefix(data.output_destination_expression),
];

export const extractWriteEntityNodeFields = (
  data: WriteEntityNodeData,
): SearchableField[] => [data.entity_objects_expression];
